import React from "react";
import FixedView from "../../../components/FixedView";
import { getBoundingClientRect } from "../../../utils/functions";
import { checkTranslation } from "../../../utils/useful";


// var moment = require('jalali-moment');
let moment = require('moment-timezone');

class DateInput extends React.Component {

    state = {
        title: moment(),
        isOpen: false,
        startOfMonth: '',
        endOfMonth: '',
        week: ['mon', 'tu', 'we', 'th', 'fr', 'sa', 'su',],
        days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,],
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        timeline: { startDate: null, endDate: null },
        setStartDate: false,
        setEndDate: false,
        // endDate: null,
        startOrEnd: "start",
        // startDate: null,
        time: [

            { name: "Today", date: moment().format('ddd') },
            { name: "Later", date: moment().add(6, 'hours').format("h:mm") },
            { name: "Tomorrow", date: moment().add(1, 'days').format("ddd") },
            { name: "Next Week", date: moment().add(1, 'week').format("ddd") },
            { name: "Next Weekend", date: "sat" },
            { name: "2 Weeks", date: moment().add(2, 'weeks').format("MMM DD") },
            { name: "4 Weeks", date: moment().add(4, 'weeks').format("MMM DD") },
            { name: "8 Weeks", date: moment().add(8, 'weeks').format("MMM DD") },
        ],
        timeLine: {},
        // currentTime
    }
    // changeDate = (index) => {
    //     console.log("change date")
    //     console.log(this.startDate.current.value)
    //     this.setState({ Date: this.startDate.current.value })
    // }
    handleChangeDate = (event) => {
        console.log('start : ', this.state.timeline.startDate);
        console.log('end : ', this.state.timeline.endDate);
        this.state.time.map((prop, index) => {
            console.log(prop)
            if (event.name == prop.name) {
                if (!this.state.setStartDate)
                    this.setState({
                        startDate: prop.date,
                        setEndDate: true

                    }
                    )
                if (this.state.setDate)
                    this.setState({
                        endDate: prop.date,
                        setStartDate: true
                    })
            }
        })
    }

    // changeInputValue(target) {
    //     let value = (target.validity.valid) ? target.value : null
    //     if (value !== null) {
    //         this.props.changeValue(this.props.header.key, value != '' ? Number(value) : null, this.props.extra)
    //     }
    // }
    setData = (key, params, value) => {
        let timeLine = this.state[key]
        timeLine[params] = value;
        console.log('setData', timeLine)
        // this.setState({timeLine,startDate:this.state.timeLine[params]},()=>{
        //     console.log('timeLine',this.state.timeLine)

        // })
        if (!this.state.startOrEnd)
            this.setState({
                timeLine,
                startDate: this.state.timeLine[params],
            }
            )
        if (this.state.startOrEnd)
            this.setState({
                timeLine,
                endDate: this.state.timeLine[params],
            })
    }
    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    componentWillMount() {
        // console.log(moment().day())
        // let now = new Date().getTime() 
        // this.setState({ title: noew })
        this.setState({ title: this.props.data, today: new Date().getTime() })
        // // this.props.changeValue(this.props.header.key, day.start)
        // console.log(new Date().getTime())
        // this.setMonth(0)
        if (this.props.data) {
            this.setMonth(0, this.props.data)

        } else {
            this.setMonth(0)
        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.data != this.props.data) {
            this.setMonth(0, this.props.data)
            this.setState({ title: this.props.data })
        }
    }

    changeMonth(number) {

        this.setMonth(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }

    setMonth(fromNow, startDate) {

        // this.setState({month:{}},()=>{


        let now = new Date();
        let days = []

        let start = moment(now).tz('Asia/Singapore').add(fromNow, 'month').startOf('month')

        if (startDate) {
            start = moment(startDate).tz('Asia/Singapore').add(fromNow, 'month').startOf('month')
        }
        // let end = moment(now).add(fromNow, 'month').endOf('month')
        // let count = 0

        for (let i = 0; i < moment(now).tz('Asia/Singapore').add(fromNow, 'month').daysInMonth(); i++) {

            days.push({ start: moment(start).tz('Asia/Singapore').add(i, 'day').startOf('day').valueOf(), end: moment(start).tz('Asia/Singapore').add(i, 'day').endOf('day').valueOf() })
            // count++
        }
        // console.log(days)

        // this.setState({ isOpen: false }, () => {
        this.setState({ month: { title: moment(start).tz('Asia/Singapore').format('YYYY-MMMM'), startDay: start.day(), days: days } })
        // })
        // console.log(start.unix())
        // console.log(end.day())
        // })
    }

    setDay(day, index) {
        // console.log("startOrEnd", this.props.startOrEnd)
        this.setState({ startOrEnd: this.props.startOrEnd ? "end" : "start" })
        // if (!this.props.startOrEnd && this.props.header.information?.startOrEnd) {
        //     startOrEnd = this.props.header.information.startOrEnd
        // }
        if (this.state.startOrEnd == "start") {
            this.props.changeValue(this.props.header.key, day["start"], this.props.extra)
            this.setState({ timeline: { ...this.state.timeline, startDate: day["start"], endDate: null }, startOrEnd: "end" })
            // this.setState({ startOrEnd: "end" }, prevState => {

            //     let timeline = Object.assign({}, prevState.timeline);  // creating copy of state variable timeline
            //     timeline.startDate = day["start"];
            //     timeline.endDate = null;                   // update the name property, assign a new value                 
            //     return { timeline };                                 // return new object timeline object
            // })
        }
        if (this.state.startOrEnd == "end") {
            console.log(day)
            console.log(day["start"] > day["end"])
            if (this.state.timeline.startDate > day["end"]) {
                console.log("TEST!!")
                this.props.changeValue(this.props.header.key, day["start"], this.props.extra)
                this.setState({ timeline: { ...this.state.timeline, startDate: day["start"], endDate: null }, startOrEnd: "end" })
            } else {
                this.props.changeValue(this.props.header.key, day["end"], this.props.extra)
                this.setState({ timeline: { ...this.state.timeline, endDate: day["end"] } })
            }
        }
        // if (this.state.timeline.startDate > this.state.timeline.endDate) {
        //     let empty=this.state.timeline.endDate
        //     this.setState({endDate:this.state.timeline.startDate,startDate:empty})
        //     // this.setState({ empty: this.state.timeline.startDate, startDate: this.state.timeline.endDate, endDate: this.state.empty })
        // }

    }
    showDays() {

        // let day = 1
        let week = []
        let weeks = []
        let days = []
        let startDay = this.state.month.startDay

        // let firstWeek = true
        let count = 0
        // console.log('startDay::',startDay)
        startDay = startDay === 0 ? 7 : startDay
        for (let i = 0; i < startDay - 1; i++) {
            days.push(null)
        }

        days = [...days, ...this.state.month.days]

        for (let i = 0; i < days.length; i++) {
            // console.log("HERE")
            count++
            week.push(days[i])
            if (count == 7 || i == days.length - 1) {
                weeks.push(week)
                count = 0
                week = []
            }
        }

        // console.log(weeks)

        let lastWeekLenght = weeks[weeks.length - 1].length
        if (lastWeekLenght < 7) {
            for (let i = 0; i < 7 - lastWeekLenght; i++) {
                // console.log("HERE")
                weeks[weeks.length - 1].push(null)
            }
        }


        // console.log(weeks)
        // console.log(weeks)
        count = 0
        return weeks.map((week, index) => {

            // if(index ==  )
            return (
                <div key={index} className="d-flex text-center pld-2 prd-2 w-100 " style={{ justifyContent: 'space-between' }}>
                    {week.map((day, index1) => {
                        // console.log(count)
                        if (day == null) {
                            return (
                                <div key={index1} style={{ width: '100%', padding: 10, width: 35 }}>
                                </div>
                            )
                        } else {
                            count++

                            let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
                            let selectedDay = (this.state.timeline.startDate == day.start || this.state.timeline.endDate == day.end) ? true : false

                            let isInMiddle = (this.state.timeline.startDate < day.start && this.state.timeline.endDate > day.end) ? true : false
                            let start = this.state.timeline.startDate == day.start ? true : false

                            let available = true

                            if (this.props.endDate && day.start > this.props.endDate) {
                                available = false
                            }

                            if (this.props.startDate && day.end < this.props.startDate) {
                                available = false
                            }
                            // if()
                            const borderRadiusStyle = isInMiddle ? 0 : (!this.state.timeline.endDate ? "50%" : start ? "50% 0 0 50%" : "0 50% 50% 0")
                            return (

                                <div onClick={() => { if (available) this.setDay(day, index) }} key={index1} style={{ cursor: 'pointer', width: '100%', backgroundColor: selectedDay ? '#007aff' : (isInMiddle ? '#007aff30' : "#fcfcfc"), padding: 0, borderRadius: borderRadiusStyle, width: 35, height: 35, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                    <div style={{ backgroundColor: isToday ? '#007aff20' : 'transparent', borderRadius: 40, padding: 0, minWidth: 25, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <span style={{ color: available ? (selectedDay ? '#fff' : '#345') : '#abc', fontSize: 12 }}>{count}</span>
                                    </div>
                                </div>
                            )
                        }
                    })
                    }

                </div>
            )
        })




    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closeBox);
        window.removeEventListener('scroll', this.getPosition);

    }

    toggleOpen(open) {
        // console.log("toggleOpen")

        let openState = open != null ? open : !this.state.isOpen

        // document.addEventListener('mousedown', this.closeBox);
        // window.addEventListener('scroll', this.getPosition, true);
        // this.getPosition()
        // if (openState) {
        this.fixedView.showView()
        // } else {
        //     this.fixedView.hideView()
        // }
        this.setState({ isOpen: true })
    }
    close(open) {
        console.log("toggleClose")
        let openState = open != null ? !this.state.isOpen : open
        this.fixedView.hideView()
        this.setState({ isOpen: false })
    }

    // closeBox = (event) => {
    //     if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
    //         this.setState({ isOpen: false, data: this.props.data })
    //         document.removeEventListener('mousedown', this.closeBox);
    //         window.removeEventListener('scroll', this.getPosition);

    //         if (this.refs.icon)
    //             this.refs.icon.classList.toggle("rotate-180")

    //     }
    // }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left })
    }



    render() {
        let info = this.props.header.information
        // console.log(this.state.title)

        return (
            <div className='mt-0 w-100 h-100 br-2' >
                {/* <label className={'mb-2 mrd-1 mld-1 ' + (info.required ? 'required' : '')} style={{ marginBottom: 3, fontSize: 12, marginTop: 5, color: '#999' }}>{info.label}</label> */}
                {/* <input disabled={info.disabled} onChange={e => { this.props.changeValue(this.props.header.key, e.target.value) }} className='form-control' defaultValue={this.props.title} placeholder={info.placeHolder} style={{ backgroundColor: '#f7f7f7', color: '#3b3a40' }} /> */}
                <div className='position-relative' ref={ref => this.setWrapperRef(ref)}>
                    <div ref={el => this.currentNode = el} onClick={() => this.toggleOpen()} disabled={info.disabled} onChange={e => { this.props.changeValue(this.props.header.key, e.target.value) }} className='' placeholder="start Date" style={{ height: 25, color: '#222', display: 'flex', alignItems: 'center' }} >
                        {console.log(this.state.timeline.startDate, this.state.timeline.endDate)}
                        <p className="input-text no-wrap date-text">start:{this.state.timeline.startDate ? moment(this.state.timeline.startDate).tz('Asia/Singapore').format('MMM DD, YYYY') : ''}</p>
                        {!this.state.title && (<p className="w-100" style={{ opacity: 0.3, minHeight: 30 }}>{checkTranslation(info.placeholder)}</p>)}
                    </div>

                    <div ref={el => this.currentNode = el} onClick={() => this.toggleOpen()} disabled={info.disabled} onChange={e => { this.props.changeValue(this.props.header.key, e.target.value) }} className='' placeholder="end Date" style={{ height: 25, color: '#222', display: 'flex', alignItems: 'center' }} >
                        <p className="input-text no-wrap date-text">end:{this.state.timeline.endDate ? moment(this.state.timeline.endDate).tz('Asia/Singapore').format('MMM DD, YYYY') : ''}</p>
                        {!this.state.title && (<p className="w-100" style={{ opacity: 0.3, minHeight: 30 }}>{checkTranslation(info.placeholder)}</p>)}
                    </div>


                    {/* {this.state.isOpen && (
                        <div style={{ position: 'fixed', top: this.state.top, backgroundColor: '#fff', borderRadius: 5, width: '270px', zIndex: 10, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', padding: 10 }}> */}

                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={-50} bottomOffset={0} zIndex={5} xOffset={-300} rightAlign={false}>

                        <div className="text-start" ref={el => this.listView = el} style={{ display: 'flex', zIndex: 5, maxWidth: 300, minWidth: 250, background: "white" }}>
                            <div className='left-calendar-part'>

                                {this.state.time.map((item, index) => {
                                    return (
                                        <div key={index} className="time-list" style={{ cursor: 'pointer', padding: '5px 11px', color: "gray" }}
                                            onClick={() => this.handleChangeDate(item)}>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
                                            ><b>{item.name}</b>{item.date}</div>
                                        </div>
                                    )
                                })}
                                <div className='set-recurring'
                                >
                                    <img src='/assets/icons/applets/desk/control.svg' />
                                    Set Recurring</div>
                            </div>
                            <div className={'search-drop-down '} style={{ direction: 'ltr', paddingBottom: 10, paddingTop: 10, display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderRadius: 8, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', border: '1px solid #eee' }}>

                                <div className="d-flex p-2" style={{ justifyContent: 'space-between' }}>
                                    {/* <i onClick={() => this.changeMonth(-1)} className="fa fa-arrow-right"></i> */}
                                    <img className="rotate-180" onClick={() => this.changeMonth(-1)} src="/images/nexts.png" height="14px" />

                                    <p>{this.state.month.title}</p>

                                    <img className="" onClick={() => this.changeMonth(1)} src="/images/nexts.png" height="14px" />

                                    {/* <i onClick={() => this.changeMonth(1)} className="fa fa-arrow-left"></i> */}
                                </div>

                                <div className="d-flex p-2  text-center w-100" style={{ justifyContent: 'space-between' }}>
                                    {this.state.week.map((prop, index) => {
                                        return (
                                            <div className={'w-100'} style={{ width: 35, }}>
                                                <p style={{ color: '#789', fontSize: 12 }}>{prop}</p>
                                            </div>
                                        )
                                    })}
                                </div>

                                {this.showDays()}
                            </div>
                            <div className='close-btn'
                                onClick={() => this.close()}
                            >Close</div>
                        </div>
                    </FixedView>
                    {/* )} */}

                </div>

            </div>
        );
    }
}

export default DateInput;
